<template>
  <companies-contact-form isolated></companies-contact-form>
</template>

<script>
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'

export default {
  components: {
    CompaniesContactForm
  }
}
</script>

<style>
  
</style>


// WEBPACK FOOTER //
// src/components/views/opensalud/ContactoEmpresas.vue